import { useLocation } from 'react-router-dom';

interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'BreadcrumbList' | 'Article' | 'FAQPage';
  data?: Record<string, unknown>;
}

const siteUrl = 'https://hznaweisi.cn';

function getDefaultSchema(type: string, pathname: string, extra?: Record<string, unknown>) {
  switch (type) {
    case 'Organization':
      return {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: '太阳娱乐',
        url: siteUrl,
        description: '太阳娱乐是值得信赖的综合娱乐平台，提供丰富多彩的娱乐项目与极致体验。',
        logo: `${siteUrl}/logo.png`,
        contactPoint: {
          '@type': 'ContactPoint',
          telephone: '+86-400-888-8888',
          contactType: 'customer service',
          availableLanguage: ['Chinese'],
        },
      };

    case 'WebSite':
      return {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: '太阳娱乐',
        url: siteUrl,
        description: '太阳娱乐 - 顶级娱乐平台官网入口',
        potentialAction: {
          '@type': 'SearchAction',
          'target': {
            '@type': 'EntryPoint',
            urlTemplate: `${siteUrl}/search?q={search_term_string}`,
          },
          'query-input': 'required name=search_term_string',
        },
      };

    case 'WebPage':
      return {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: extra?.name || '太阳娱乐',
        url: `${siteUrl}${pathname}`,
        description: extra?.description || '太阳娱乐官方页面',
        isPartOf: {
          '@type': 'WebSite',
          name: '太阳娱乐',
          url: siteUrl,
        },
      };

    case 'BreadcrumbList': {
      const items = (extra?.items as Array<{ name: string; url?: string }>) || [];
      return {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: items.map((item, index) => ({
          '@type': 'ListItem',
          position: index + 1,
          name: item.name,
          item: item.url ? `${siteUrl}${item.url}` : undefined,
        })),
      };
    }

    case 'Article':
      return {
        '@context': 'https://schema.org',
        '@type': 'Article',
        headline: extra?.headline || '',
        description: extra?.description || '',
        url: `${siteUrl}${pathname}`,
        datePublished: extra?.datePublished || '',
        dateModified: extra?.dateModified || extra?.datePublished || '',
        author: {
          '@type': 'Organization',
          name: '太阳娱乐',
        },
        publisher: {
          '@type': 'Organization',
          name: '太阳娱乐',
          logo: {
            '@type': 'ImageObject',
            url: `${siteUrl}/logo.png`,
          },
        },
        image: extra?.image || '',
      };

    case 'FAQPage': {
      const questions = (extra?.questions as Array<{ question: string; answer: string }>) || [];
      return {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: questions.map((q) => ({
          '@type': 'Question',
          name: q.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: q.answer,
          },
        })),
      };
    }

    default:
      return {};
  }
}

export default function SchemaOrg({ type, data }: SchemaOrgProps) {
  const location = useLocation();

  const schema = data || getDefaultSchema(type, location.pathname);

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}